import {Model} from 'mobx-rest'
import has from 'lodash/has'
import {CpeId} from "./deviceFeatureSets/deviceOp/cpeId";
import { cancelJobs } from "./policyJobs/cancelJobs";

/*
 * Model used to save policyJobs object
 */
class _policyJobs extends Model {
    url() {
        return '/policyJobs';
    }
}

export class policyJobs extends Model {
    constructor(attributes) {
        super(Object.assign({}, attributes));
        this._originalObject = null;
        this._cancelJobs = {};
    }
    urlRoot() {
        return '/policyJobs'
    }
    fetch(data) {
        const self = this;
        return super.fetch()
            .then( val => {
                    // console.log(val);
                    self._originalObject = val;
                    self.reset(val);
                    // self.commitChanges();
                })
    }
    save(attributes, options) {
        const changed = this.changes.jobs;
        const added = changed.filter(obj => !has(obj, 'taskId'));

        const model = new _policyJobs(added.length > 0 ? added[0] : {})
        const request = model.save().then(value => {
            this.fetch()
        });
        return request;
    }
    cancelJobs(attributes) {
        const key = JSON.stringify(attributes);
        if (!this._cancelJobs[key]) {
            this._cancelJobs[key] = new cancelJobs(attributes);
        }
        return this._cancelJobs[key];
    }
}
